import { render, staticRenderFns } from "./SharingEntrySimple.vue?vue&type=template&id=4c49edf4&scoped=true"
import script from "./SharingEntrySimple.vue?vue&type=script&lang=js"
export * from "./SharingEntrySimple.vue?vue&type=script&lang=js"
import style0 from "./SharingEntrySimple.vue?vue&type=style&index=0&id=4c49edf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49edf4",
  null
  
)

export default component.exports